import { styled } from '@mui/material/styles';
import { MenuItem } from '@mui/material';
import { Colors } from '../../../constants';

export const CoreMenuItem = styled(MenuItem)(({ theme }) => ({
	padding: '8px 16px',
	fontFamily: 'Montserrat, sans-serif',
	fontWeight: 600,
	fontSize: '14px',
	lineHeight: '124%',

	'&:hover': {
		backgroundColor: Colors['2A2A2A'],
	},

	[theme.breakpoints.up('sm')]: {
		padding: '10.5px 16px',
		borderBottom: `1px solid ${Colors.white_a5}`,

		'&:last-of-type': {
			borderBottomWidth: 0,
		},
	}
}));
